import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth0 } from "@auth0/auth0-react";

import { Create } from "components/pages/account/registration/create/Create";
import { ReadOnlyCreate } from "components/pages/account/registration/create/readOnlyCreate/ReadOnlyCreate";
import { SliderPageWrapper } from "../../layout/sliderPageWrapper/SliderPageWrapper";

import { useRootSelector } from "store/hooks";
import { selectedAccountInfo } from "store/account/account-selector";
import React, { useEffect } from "react";
import { ReAuthContext } from "context/ReAuthContext";

export const AccountDetail = () => {
  const { meta, user } = useRootSelector((state) => state.user);
  const { state: reAuthState, dispatch: reAuthDispatch } =
    useContext(ReAuthContext);
  const accountInfo = useRootSelector(selectedAccountInfo);
  const { loginWithRedirect } = useAuth0();

  const [editMode, setEditMode] = useState(false);
  const { client } = useRootSelector((state) => state.config);

  useEffect(() => {
    if (
      reAuthState.isReauthenticated &&
      reAuthState.purpose === "EditAccountDetails"
    ) {
      reAuthDispatch({ type: "RESET_REAUTH" });
      setEditMode(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const editHandler = () => {
    if (!editMode) {
      reAuthDispatch({
        type: "SET_REAUTH",
        payload: { purpose: "EditAccountDetails" },
      });
      const returnTo = window.location.pathname + window.location.search;
      loginWithRedirect({
        authorizationParams: {
          screen_hint: "login",
          prompt: "login",
          redirect_uri: `${window.location.origin}/${client.customerKey}/dashboard/settings`,
        },
        appState: {
          returnTo: returnTo,
        },
      });
    } else {
      setEditMode(!editMode);
    }
  };

  const { t } = useTranslation(["account"]);
  return (
    <SliderPageWrapper headerTitle={t("account:account_details")}>
      {meta.isLoading ? <ft-screen-loader></ft-screen-loader> : null}
      {user && accountInfo ? (
        editMode ? (
          <Create editHandler={editHandler} editMode={editMode} />
        ) : (
          <ReadOnlyCreate
            user={user}
            accountInfo={accountInfo}
            editHandler={editHandler}
          />
        )
      ) : null}
    </SliderPageWrapper>
  );
};
